import  { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './EngineeringIntelligence.scss';
import duotone from '../../assets/Images/Engineering/duotone.svg'
import cluster from '../../assets/Images/Engineering/cluster.svg'

const TAB_DATA = [
  'AI & Machine Learning',
  'Internet of Things (IoT)',
  'Software Development',
  'Startup Product Development',
  'Design & UX'
];

const DELIVERABLES_DATA = [
  { id: 1, title: 'Predictive analytics solutions', icon: duotone },
  { id: 2, title: 'Custom AI model development', icon: duotone },
  { id: 3, title: 'NLP & conversational AI', icon: duotone },
  { id: 4, title: 'Computer vision systems', icon: duotone },
  { id: 5, title: 'Automation pipelines', icon: duotone },
];

export default function EngineeringIntelligence() {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <section className="engineering-intelligence">
      
      {/* Top Header Section */}
      <div className="ei-header-section">
        <div className="cluster-capsule">
          <div className="icon-wrapper">
            <div className="icon-blur" aria-hidden="true"></div>
            <img src={cluster} alt="cluster" className="cluster-icon" />
          </div>
          <span>Cluster B: Finance</span>
        </div>

        <h2 className="ei-heading">
          Engineering Intelligence.
          <br />
          <span className="highlight-box">Building the Future.</span>
        </h2>

        <p className="ei-subheading">
          At Logiqlink, we combine strategy, design, and engineering to build scalable digital ecosystems. From AI-powered platforms to IoT infrastructure and startup-ready products — we don’t just build tech, we build impact.
        </p>
      </div>

      {/* Interactive Tabs Section */}
      <div className="ei-tabs-container">
        
        {/* Tab Navigation */}
        <div className="ei-tabs-header">
          {TAB_DATA.map((tab, index) => (
            <button
              key={index}
              className={`ei-tab-btn ${activeTab === index ? 'active' : ''}`}
              onClick={() => setActiveTab(index)}
            >
              {tab}
            </button>
          ))}
        </div>

        {/* Tab Content Box */}
        <div className="ei-tab-content-box">
          <AnimatePresence mode="wait">
            <motion.div
              key={activeTab}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.3, ease: 'easeInOut' }}
            >
              <div className="ei-content-header">
                <h3>Turn data into decisions. Automate intelligently.</h3>
                <p>We design and deploy AI-driven systems that learn, predict, and optimize in real time.</p>
              </div>

              <div className="ei-deliverables">
                <span className="italic-label">What we deliver:</span>
                <div className="ei-cards-grid">
                  {DELIVERABLES_DATA.map((item) => (
                    <div key={item.id} className="ei-deliverable-card">
                      <img src={item.icon} alt={item.title} className="card-icon" />
                      <p>{item.title}</p>
                    </div>
                  ))}
                </div>
              </div>

              <div className="ei-outcome">
                <span className="italic-label">Outcome:</span>
                <p>Smarter workflows. Better forecasting. Competitive advantage.</p>
              </div>
            </motion.div>
          </AnimatePresence>
        </div>

      </div>
    </section>
  );
}